import React, {Component} from 'react';
import { Alert } from 'antd';
import _ from 'lodash'
import styles from './styles.module.scss';
import Errors from 'validatorjs/src/errors';

export default class ValidatorErrorAlert extends Component {
  render() {

    const errors = _.get(this,'props.errors',new Errors())

    if (_.isEmpty(errors.all())) return (null)
    
    return <Alert className='formAlert'
                 showIcon 
                 type="warning"
                 message="提醒"
                 description={_.keys(errors.all()).map(key => 
                  <div>
                    <a onClick={() => {
                        console.log('key', key)
                        let element = document.querySelector(`[name="${key}"]`)

                        if (!element) return 

                        element.scrollIntoView({ behavior:'smooth', block:'center'})
                    }}>
                      {errors.first(key)}
                    </a>
                  </div>
                 )}
              />
  }
}


// WEBPACK FOOTER //
// ./src/components/ValidatorErrorAlert/ValidatorErrorAlert.js